// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Tajawal_e731e2'","fontStyle":"normal"},"className":"__className_e731e2","variable":"__variable_e731e2"};